module.exports = __webpack_public_path__ + "img/樱花桃花飘落.d6bbc833.gif";